import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { ErrorBoundary } from "vino/core";
import { AppContextProvider } from "vino/context/AppContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Layout2 from "./Layout2";
import store from "./store";
import { Login, ProductList, WineEvents } from "vino/components";
import Checkout from "vino/components/cart-checkout/Checkout/Checkout";
import Invoice from "vino/components/Invoice";
import EventBooking from "vino/components/WineEventBooking/EventBooking";
import BookingDetails from "vino/components/WineEventBooking/BookingDetails";
import AccountPage from "vino/components/Accounts/HomePage";
import CustomerBookings from "vino/components/CustomerBookings";
import WineClubSubscriptions from "vino/components/WineClubSubscriptions";
import SubscriptionList from "vino/components/Subscriptions/SubscriptionList";

const App = () => {
	return (
		<BrowserRouter>
			<ErrorBoundary>
				<Provider store={store}>
					<SnackbarProvider>
						<AppContextProvider>
							<Layout2>
								<Layout>
									<Routes>
										<Route path="/" element={<Login />} />
										<Route path="/" element={<ProductList />} />
										<Route path="/checkout" element={<Checkout />} />
										<Route path="/invoice" element={<Invoice />} />
										<Route path="/login" element={<Login />} />
										<Route path="/wineEvent" element={<WineEvents />} />
										<Route path="/event-booking" element={<EventBooking />} />
										<Route path="/my-account" element={<AccountPage />} />
										<Route path="/my-events" element={<CustomerBookings />} />
										<Route
											path="/subscription"
											element={<SubscriptionList />}
										/>
										<Route
											path="wineclub"
											element={<WineClubSubscriptions />}
										/>
										<Route
											path="/event-Booking-Details"
											element={<BookingDetails />}
										/>
									</Routes>
								</Layout>
							</Layout2>
						</AppContextProvider>
					</SnackbarProvider>
				</Provider>
			</ErrorBoundary>
		</BrowserRouter>
	);
};

export default App;
